import React, {useEffect, useState} from "react";
import {
    getAvailableClientServiceTypes,
    getCurrentUser,
    getOptionsByData, isEmpty
} from "../../../../_helpers/commonFunctions";
import {Accordion, Button, Col, Row} from "react-bootstrap";
import {useDispatch, useSelector} from "react-redux";
import {
    fetchAdvancedTypesSales,
    fetchSalesGeneralSettings
} from "../../../../_apis/api";
import Dropdown from "../../../primer/Dropdown";
import {
    providedServiceCategoryOptionsForIssue,
    providedServiceCategoryOptionsForNoIssue,
    serviceTypeOptionsSettings
} from "./dclStatusOptions";
import {setSaveSalesSettings} from "../../../../_reducers/activitySlice";
import {setSalesGeneralSettings} from "../../../../_reducers/DataPanel/Sales/salesSettingsSlice";
import MassFetchDclModal from "./MassFetchDclModal";
import BetterCheckBox from "../../../common/BetterCheckBox";
import AdvancedCombobox from "../../../primer/AdvancedCombobox";
import axios from "axios";
import {useTranslation} from "../../../../hooks/useTranslation";

const DclSettings = () => {
    const {t} = useTranslation();
    const ACTIVITY = useSelector((state) => state.ACTIVITY);
    const SETTINGS = useSelector((state) => state.SETTINGS);
    const saleSettingsSlice = useSelector((state) => state.SALES_SETTINGS?.salesGeneralSettings);
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const companyInstallations = useSelector((state) => state.COMPANY_DATA.companyInstallations);
    const [installationOptions, setInstallationOptions] = useState([]);
    const permissionsData = JSON.parse(localStorage.getItem("permissions"));
    const clientServiceTypes = getAvailableClientServiceTypes(permissionsData);
    const dispatch = useDispatch();
    const [showMassFetchDclModal, setShowMassFetchDclModal] = useState(false);
    const [productListData, setProductListData] = useState([]);
    const documentTypesOptions = [
        {value: "noIssue", label: "Μη Έκδοση Παραστατικού"},
        ...getOptionsByData(SETTINGS.settings.advancedTypesSales?.filter((doc) => doc.mydataProvider === "active" && doc.myDataType !== "11.4" && doc.myDataType !== "5.2" && doc.myDataType !== "5.1"), "_id", "name")];
    const productCodeColumns = [
        {
            label: t('SalesNew.productCodeTable.code'),
            name: "code",
        },
        {
            label: t('SalesNew.productCodeTable.alternativeCode'),
            name: "alternateCode",
        },
        {
            label: t('SalesNew.productCodeTable.productName'),
            name: "name",
        },
        {
            label: t('SalesNew.productCodeTable.alternativeName'),
            name: "alternateName",
        },
    ];

    const loadProductListData = (keyword, documentType) => {
        let data = {
            id: documentType,
            name: keyword,
            company : company.id,
        }
        if(isEmpty(documentType)) {
            return setProductListData([]);
        }
        axios.get(process.env.REACT_APP_API_URL2 + `/sale/product-list-by-advanced-type-id/${data.id}`,{params :data})
            .then(res => {
                if (res.data && res.data.status === '200') {
                    if (res.data.data) {
                        setProductListData(res.data.data);
                    } else {
                        setProductListData([]);
                    }
                } else {
                    setProductListData([]);
                }
            }).catch((err) => {
            console.log(err);
        })
    }
    const currentUser = getCurrentUser();
    const requestData = {
        company: company.id,
        year: company.year.toString(),
        isActive: "active",
        userId: currentUser.id,
    }

    useEffect(() => {
        dispatch(fetchSalesGeneralSettings(requestData));
    }, []);

    useEffect(() => {
        if (companyInstallations.length > 0) {
            let options = [];
            companyInstallations.forEach((inst) => {
                options.push({ value: inst.installationMasterId, label: inst.type + " " + inst.address + " " + inst.city });
            })
            setInstallationOptions(options);
        }
        dispatch(fetchAdvancedTypesSales({company: company.id}));
    }, []);

    const handleOnChange = (installation, key, value) => {
        if (!ACTIVITY.saveSalesSettings) {
            dispatch(setSaveSalesSettings(true));
        }
        let salesGeneralSettings = structuredClone(saleSettingsSlice?.dclInstallationDefaultOptions || []);
        let installationSettings = salesGeneralSettings?.find((ins) => ins?.installation === installation) ?? {installation: installation, clientServiceType: "", serviceCategory: "", providedServiceCategory: "", documentType: ""};
        if(key === "documentType") {
            installationSettings[key] = value.value;
            installationSettings["documentTypeName"] = value.label;
        } else if(key === "product") {
            installationSettings[key] = value?.row?._id || "";
            installationSettings["productName"] = value?.row?.name || "";
        } else {
            installationSettings[key] = value;
        }
        const foundIndex = salesGeneralSettings?.findIndex((el) => el?.installation === installation);
        if(foundIndex !== -1) {
            salesGeneralSettings[foundIndex] = installationSettings;
        } else {
            salesGeneralSettings.push(installationSettings);
        }
        if(key === "selected" && value === true) {
            salesGeneralSettings.map((ins) => {
                    if (String(ins?.selected) === "true" && ins.installation !== installation) {
                        ins.selected = false;
                    }
                    return ins;
                })
            }
        dispatch(setSalesGeneralSettings({...saleSettingsSlice, dclInstallationDefaultOptions: salesGeneralSettings}));
    }


    return (
        <React.Fragment>
            <p className="text-muted">
                <i>Προκαθορισμένες Τιμές ανά εγκατάσταση:</i>
            </p>
            {installationOptions.map((inst, idx) => {
                const foundSetting = saleSettingsSlice?.dclInstallationDefaultOptions?.find((ins) => ins?.installation === inst.value);
                const findOpened = saleSettingsSlice?.dclInstallationDefaultOptions?.find((op) => String(op.selected) === "true") ? saleSettingsSlice?.dclInstallationDefaultOptions?.find((op) => String(op.selected) === "true")?.installation : "0";
                return (
                    <Accordion key={String(idx)} defaultActiveKey={String(inst.value) === String(findOpened) ? String(idx) : ""} className={"mb-2 custom-accordion"}>
                    <Accordion.Item eventKey={String(idx)}>
                        <Accordion.Header>{inst?.label}</Accordion.Header>
                        <Accordion.Body>
                            <Row className={"mb-2"}>
                                <Col md={4}>
                                    <Dropdown
                                        name={"clientServiceType"}
                                        className={"w-100"}
                                        label={"Τύπος Ψηφιακού Πελατολογίου"}
                                        defaultValue={clientServiceTypes.find((el) => el.value === foundSetting?.clientServiceType)}
                                        key={Math.random()}
                                        options={clientServiceTypes}
                                        onChange={(e) => handleOnChange(inst.value, "clientServiceType", e.value)}
                                    />
                                </Col>
                                <Col md={4}>
                                    <Dropdown
                                        name={"serviceCategory"}
                                        className={"w-100"}
                                        label={"Τύπος Υπηρεσίας"}
                                        defaultValue={serviceTypeOptionsSettings.find((el) => el.value === foundSetting?.serviceCategory)}
                                        key={Math.random()}
                                        options={serviceTypeOptionsSettings}
                                        onChange={(e) => handleOnChange(inst.value, "serviceCategory", e.value)}
                                    />
                                </Col>
                                <Col md={4}>
                                    <Dropdown
                                        name={"documentType"}
                                        className={"w-100"}
                                        label={"Τύπος Παραστατικού"}
                                        defaultValue={documentTypesOptions.find((el) => el.value === foundSetting?.documentType)}
                                        key={Math.random()}
                                        options={documentTypesOptions}
                                        onChange={(e) => handleOnChange(inst.value, "documentType", e)}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col md={4}>
                                    <Dropdown
                                        name={"providedServiceCategory"}
                                        className={"w-100"}
                                        label={"Παρεχόμενη Υπηρεσία"}
                                        defaultValue={(foundSetting?.documentType !== "noIssue" ? providedServiceCategoryOptionsForIssue : providedServiceCategoryOptionsForNoIssue).find((el) => el.value === foundSetting?.providedServiceCategory)}
                                        key={Math.random()}
                                        options={foundSetting?.documentType !== "noIssue" ? providedServiceCategoryOptionsForIssue : providedServiceCategoryOptionsForNoIssue}
                                        onChange={(e) => handleOnChange(inst.value, "providedServiceCategory", e.value)}
                                    />
                                </Col>
                                <Col md={5}>
                                    <div className="d-flex justify-content-between">
                                    <AdvancedCombobox
                                        name={"defaultProduct"}
                                        className={"w-100 ac-select-dropdown flex-grow-1"}
                                        defaultValue={foundSetting?.product ? foundSetting?.productName : ""}
                                        label={"Επιλεγμένο Προϊόν κατά την έκδοση παραστατικού"}
                                        data={productListData}
                                        onChange={(e) => handleOnChange(inst.value, "product", e)}
                                        key={`defaultProduct${idx}${foundSetting?.product}`}
                                        onFocus={() => loadProductListData('', foundSetting?.documentType)}
                                        onChangeSearch={(keyword, setData) => loadProductListData(keyword, foundSetting?.documentType)}
                                        excludeColumns={[]}
                                        columns={productCodeColumns}
                                        deleteEnable={false}
                                        searchTableEnable={false}
                                        showTableOptionOnSelect={true}
                                        placeholder={"Πληκτρολογήστε και επιλέξτε Προϊόν"}
                                        required={true}
                                        showInsertAddButton={true}
                                        hideSaveButton={true}
                                        hideInsertNewRow={true}
                                        inputFieldClasses="form-control"
                                    />
                                    {foundSetting?.product && (
                                            <button className="btn quick-retail-clientbtn btn-default btn-sm ml-1 mt-4"
                                                    title="Clear Product" key={Math.random()}
                                                    onClick={() => handleOnChange(inst.value, "product", "")}><i className="fas fa-xmark"></i></button>
                                        )}
                                    </div>
                                </Col>
                                <Col md={3}>
                                    <div style={{marginTop: "33px"}}>
                                        <BetterCheckBox
                                            name={"selected"}
                                            text={"Προεπιλεγμένη Εγκατάσταση"}
                                            checked={String(foundSetting?.selected) === "true"}
                                            onChange={(e) => handleOnChange(inst.value, "selected", e.target?.checked)}
                                        />
                                    </div>
                                </Col>
                            </Row>
                        </Accordion.Body>
                    </Accordion.Item>
            </Accordion>
                )
            })}
            <hr />
            <p className="text-muted">
                <i>Λοιπές Λειτουργίες:</i>
            </p>
            <Button className={"mb-2"} size="sm" onClick={() => setShowMassFetchDclModal(true)}>
                Μαζική Άντληση Δεδομένων από MyData<i className="fa-solid fa-rotate ml-1" style={{fontSize: "12px"}}></i>
            </Button>
            <MassFetchDclModal show={showMassFetchDclModal} setShow={setShowMassFetchDclModal} />
        </React.Fragment>
    )
}

export default DclSettings;
